__turbopack_context__.v({
  "disabled": "C7L2mW_disabled",
  "leftIcon": "C7L2mW_leftIcon",
  "rightIcon": "C7L2mW_rightIcon",
  "textWithIcon": "C7L2mW_textWithIcon",
  "token": "C7L2mW_token" + " " + __turbopack_context__.i(248112)["focusOutline"],
});
